import {Namespace} from 'i18next';
import {useTranslation} from 'react-i18next';

import {TFunction} from './t-function';

interface UseOurTranslationProps<T extends Namespace> {
    /** Namespace-specific translation function. */
    t: TFunction<T>;
    /** Shared common translation function. */
    tCommon: TFunction<'common'>;
}

/**
 * Returns both the requested namespace translator and the shared common translator.
 *
 * @param namespace Namespace requested by the caller.
 * @returns Namespace translation helpers for the requested screen.
 *
 * @example
 * const {t, tCommon} = useOurTranslation('system/system');
 */
export function useOurTranslation<T extends Namespace>(namespace: T): UseOurTranslationProps<T> {
    const [t] = useTranslation(namespace);
    const [tCommon] = useTranslation('common');

    return {t, tCommon};
}
